import { ApiProvider } from "@sb1finans/components/dist/ApiProvider";
import { CustomThemeProvider } from "@sb1finans/components/dist/themes/CustomThemeContext";
import React from "react";
import { SB1ErrorBoundary } from "@sb1finans/components/dist/Sb1ErrorBoundary";
import {
  createLogger,
  AppInsightsLogger,
  LogLevel,
  LoggerProvider,
} from "@sb1finans/components/dist/SB1Logger";
import Container from "@mui/material/Container";
import ChargebackForm from "./components/form";
import { Sb1Toolbar } from "@sb1finans/components/dist/Sb1Toolbar";
import { createRoot } from "react-dom/client";

let logger;
if (process.env.NODE_ENV !== "development") {
  console.log("Production environmenrt!");
  logger = createLogger({
    interceptors: [
      AppInsightsLogger({
        instrumentationKey: "e2a8fa89-f6f6-4058-bd27-0a0714ade024",
      }),
    ],
    captureConsole: true,
    logLevel: LogLevel.INFO,
  });
} else {
  console.log("DEV environmenrt!");
  /*const worker = setupWorker(...handlers)
    worker.start()*/
  logger = createLogger({
    interceptors: [],
    captureConsole: true,
  });
}

const configUrl = `${process.env.PUBLIC_URL}/config/config.json`;
fetch(configUrl)
  .then((response) => response.json())
  .then((json) => {
    console.log("Config is: ", json);
    return json;
  })
  .then((config) => {
    console.info("Initializing app collection with config: ", config);
    const rootElement = document.getElementById("root") as HTMLElement;
    const root = createRoot(rootElement);

    root.render(
      <React.StrictMode>
        <LoggerProvider logger={logger}>
          <SB1ErrorBoundary>
            <ApiProvider config={config}>
              <CustomThemeProvider>
                <App />
              </CustomThemeProvider>
            </ApiProvider>
          </SB1ErrorBoundary>
        </LoggerProvider>
      </React.StrictMode>,
    );
    console.info("App mypage initialized.");
  });

const App = () => {
  return (
    <Container maxWidth="sm">
      <ChargebackForm />
    </Container>
  );
};
